module.exports = __webpack_public_path__ + "img/Strawberry.0fe4ded7.svg";